import React from 'react'
import Form from 'react-bootstrap/Form'

// Styles
import './index.scss'

const InputText = (props) => {
  const { title, type, field, placeholder, className, style } = props
  return (
    <div className="e-input">
      <Form.Group controlId="exampleForm.ControlInput1">
        {
          title && <label className="e-label white">{title}</label>
        }
        <Form.Control
          className={className}
          {...field}
          type={type}
          placeholder={placeholder}
          style={style}
        />
      </Form.Group>
    </div>
  )
}

export default InputText